export default "/*Pic\n*/\n.pic {\n    float: left;\n}\n";